import type { ReportingModelDataSourceDeclaration } from '@de/providers/DataSourceManager.types';
import { reportingDerivedRoots } from '../interpolateReportingBody';
import {
  buildReportingModelRequest,
  fetchReportingModelDataSource,
} from '../fetchReportingModelDataSource';
import type { DataSourceTypeDescriptor } from '../source-type-registry';

/**
 * A declarative reporting query. The URL is host-supplied, so nothing in the
 * authored declaration names an endpoint.
 */
export const reportingModelSourceType: DataSourceTypeDescriptor<ReportingModelDataSourceDeclaration> =
  {
    kind: 'reportingModel',

    buildRequest(decl, context, host) {
      return buildReportingModelRequest(decl, context, host.reportingQueryUrl);
    },

    fetch(request, decl, options) {
      return fetchReportingModelDataSource(decl, undefined, {
        ...options,
        preparedRequest: request,
      });
    },

    isSupported(decl) {
      return (
        typeof decl.modelId === 'string' &&
        Array.isArray(decl.metrics) &&
        decl.metrics.length > 0
      );
    },

    interpolatableFields(decl) {
      return [
        decl.modelId,
        decl.metrics,
        decl.dimensions,
        decl.segments,
        decl.filters,
        decl.having,
        decl.order,
        decl.limit,
        decl.context,
        decl.boundFilters,
        decl.applicableFormKeys,
        decl.excludeEqFields,
        decl.sequenceBindings,
        decl.valueSelections,
        decl.formOverrides,
      ];
    },

    derivedRoots(decl, context) {
      return reportingDerivedRoots(decl, context);
    },
  };
